import React from 'react'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../common/integrations'
import { IntegrationUserActionButton } from './IntegrationUserActionButton'
import { openIntegrationConnectionSettings } from './utils'

interface IntegrationConnectionButtonProps {
  serviceId: IntegrationServiceId
  onClick: () => void
}

export const ConnectIntegrationButton: React.FC<IntegrationConnectionButtonProps> = ({ serviceId, onClick }) => {
  const handleClick = () => {
    onClick()
    openIntegrationConnectionSettings(serviceId)
  }

  return <IntegrationUserActionButton serviceId={serviceId} label={`Connect ${getIntegrationDisplayName(serviceId)}`} onClick={handleClick} />
}

export const ReconnectIntegrationButton: React.FC<IntegrationConnectionButtonProps> = ({ serviceId, onClick }) => {
  const handleClick = () => {
    onClick()
    openIntegrationConnectionSettings(serviceId)
  }

  return <IntegrationUserActionButton serviceId={serviceId} label={`Reconnect ${getIntegrationDisplayName(serviceId)}`} onClick={handleClick} />
}
